export default {
  noDataDescription: 'No data found for selected sensors and timeframe.',
};
